<template>
  <div id="map" ref="leafletMap" class="z-10 h-full w-full" />
</template>

<script setup lang="ts">
import L, { type MapOptions } from 'leaflet'
import 'leaflet.fullscreen'
import 'leaflet/dist/leaflet.css'
import 'leaflet.fullscreen/Control.FullScreen.css'
import type { CottagePage } from '../entities/CottagePage'
import iconMap from '/__nuxt-public/images/icon_map.png'
import { useIntersectionObserver } from '@vueuse/core'

type itemType = Pick<CottagePage, 'latitude' | 'longitude'>

interface CustomMapOptions extends MapOptions {
  fullscreenControl?: boolean
}

interface propsInterface {
  item: itemType
}

const props = defineProps<propsInterface>()

const map = ref<L.Map | null>(null)
const leafletMap = ref<HTMLElement | null>(null)
const zoom = 10
const minZoom = 1
const maxZoom = 19
const iconUrl = iconMap

onMounted(async () => {
  await nextTick()

  if (leafletMap.value) {
    let mapLoaded = false
    map.value = L.map(leafletMap.value, {
      center: [props.item.latitude, props.item.longitude],
      zoom,
      minZoom,
      maxZoom,
      fullscreenControl: true,
    } as CustomMapOptions)

    useIntersectionObserver(leafletMap, ([entry]) => {
      if (entry?.isIntersecting && !mapLoaded) {
        mapLoaded = true
        L.tileLayer('https://mapas.escapadarural.com/hot/{z}/{x}/{y}.png', {
          maxZoom,
          attribution:
            'Map data: &copy; <a href="http://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>',
        }).addTo(map.value as L.Map)

        const customIcon = L.icon({
          iconUrl,
          iconSize: [30, 38],
        })

        L.marker([props.item.latitude, props.item.longitude], {
          icon: customIcon,
        }).addTo(map.value as L.Map)
      }
    })
  }
})
</script>
